import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ReportBooleanOption } from 'app/shared/components/report-boolean-option/report-boolean-option.component';
import { environment } from 'environments/environment';

@Component({
  templateUrl: './capture-admin-capture-reports.component.html',
  standalone: false
})
export class CaptureAdminCaptureReportsComponent {
  reportsUrl = `${environment.captureApi.url}/capture_reports`;
  reportsCountUrl = `${environment.captureApi.url}/capture_reports/count`;

  constructor(
    private formBuilder: UntypedFormBuilder,
  ) {}

  filtersForm = this.formBuilder.group({
    statusAndReasons: [null],
    clientIds: [null],
    highValueCandidatesOnly: [null],
    expiringWithinDays: [null],
    activeClientsOnly: [new ReportBooleanOption(true), null],
    sources: [null],
    pharmacyNames: [null],
    verifiedDate: [null],
    createdDate: [null]
  });

  outputOptionsForm = this.formBuilder.group({
    includePhi: [null],
  });
}
